import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, loading, isAuthenticated } = useContext(AuthContext);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="w-12 h-12 rounded-full border-t-2 border-b-2 animate-spin border-green-aqua"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    const intendedUrl = window.location.pathname + window.location.search;
    const isHome = intendedUrl === "/" || intendedUrl === "";
    
    // Solo guardar la URL de redirección si no estamos en home y no hay una ya guardada
    if (!window.isLoggingOut && !localStorage.getItem('redirectAfterLogin') && !isHome) {
      localStorage.setItem('redirectAfterLogin', intendedUrl);
    }
    
    // Limpiar la bandera de logout
    if (window.isLoggingOut) {
      window.isLoggingOut = false;
    }
    
    return <Navigate to="/" replace />;
  }

  // Verificar que el usuario tenga los datos necesarios
  if (!user || !user.id) {
    return <Navigate to="/" replace />;
  }

  return children || <Outlet />;
};

export default PrivateRoute;
